import { appendToUrl, scrollLock } from '../util';
import { handleEscapeKey, trapModalFocus } from '../a11yHelper';
import { updateUrl } from '../searchHelpers';

const MOBILE_WIDTH = 768;
const markers = [];

const getSelectedFilters = () => $('.js-filter-button.selected').map((i, filter) => $(filter).attr('name')).get();

const postalCodeStore = (pid) => {
    if (!pid) {
        return false;
    }

    const $storesPagination = $('.js-stores-pagination');
    const storesElements = $storesPagination.children().toArray();

    return storesElements.length === 1 && storesElements.every((store) => {
        const selectButton = $(store).find('.js-select-club-new-checkout');
        return selectButton.attr('data-pid') === pid;
    });
};

const promotionLabelTooltip = () => {
    $(document).on({
        mouseenter: (e) => {
            $(e.currentTarget).children().addClass('show');
        },
        mouseleave: (e) => {
            $(e.currentTarget).children().removeClass('show');
        },
        click: (e) => {
            if ($(window).width() < MOBILE_WIDTH) {
                e.preventDefault();
                $(e.currentTarget).children().toggleClass('show');
            }
        },
    }, '.js-tooltip-icon');
};

// ToolTip Modal (With Open and Close Function)
const infoTooltipModal = (ani) => {
    let aniClass = '';
    let lastFocusedButton = null;

    if (ani === 'from-side') {
        aniClass = 'from-side';
    }

    $('body').off('click', '.js-tooltip-modal-icon');
    $('body').on('click', '.js-tooltip-modal-icon', function (e) {
        lastFocusedButton = this;
        const target = e.currentTarget;

        $(this).next('.tooltip-content').removeAttr('inert');

        if ($(target).hasClass('tooltip-modal-icon--disabled')) {
            return;
        }

        // Close ToolTip
        function closeToolTip() {
            $('.tt-modal').removeClass('show');
            $('body').removeClass('tt-popup-overlay');
            scrollLock('off');

            setTimeout(() => {
                $('.tt-modal, .js-tt-ms-overlay').remove();
                if (lastFocusedButton) {
                    $(lastFocusedButton).trigger('focus'); // Ensure focus returns to the button
                    $(lastFocusedButton).next('.tooltip-content').attr('inert', '');
                }
            }, 100);
        }

        const ttContent = $(target).next('.tooltip-content').html();

        if ($('.tt-modal').length === 1) {
            if (aniClass) {
                $('.tt-modal').addClass(aniClass);
            }
            $('.tt-modal .tooltip-content').html(ttContent);
            $('.tt-modal').addClass('show');
            $('body').addClass('tt-popup-overlay');
            scrollLock('on');

            setTimeout(() => {
                $('.js-tt-ms-modal-close').trigger('focus');
                trapModalFocus($('.tt-modal'));
            }, 300);
        } else {
            $('.page').append(`
                <div class="tt-modal ${aniClass}" tabindex="-1">
                    <button class="modal-close js-tt-ms-modal-close"></button>
                    <div class="tooltip-content"></div>
                </div>
                <div class="tt-overlay js-tt-ms-overlay"></div>
            `);
            $('.tt-modal .tooltip-content').html(ttContent);

            setTimeout(() => {
                $('.tt-modal').addClass('show');
                $('body').addClass('tt-popup-overlay');
                scrollLock('on');
                requestAnimationFrame(() => {
                    $('.js-tt-ms-modal-close').trigger('focus');
                    trapModalFocus($('.tt-modal'));

                    // Close on Escape key
                    $(document).on('keydown', (event) => {
                        handleEscapeKey(event, () => {
                            if ($('.tt-modal').hasClass('show')) {
                                closeToolTip();
                            }
                        });
                    });
                });
            }, 300);
        }

        $('body').on('click', (event) => {
            const $target = $(event.target);

            if ($target.is('.js-tt-ms-modal-close') || $target.is('.js-tt-ms-overlay')) {
                closeToolTip();
            }
        });
    });
};

const selectPointer = (e) => {
    $('.checkout-navigation .mapboxgl-canvas-container div.purple').removeClass('purple');
    $(e.currentTarget).addClass('purple');
};

const customPointers = () => {
    $('.checkout-navigation .mapboxgl-interactive div').each((i, pointer) => {
        const $pointer = $(pointer);
        $pointer.addClass('no-image');
        $pointer.off('click', selectPointer);
        $pointer.on('click', selectPointer);
    });
};

const showMapboxMarkers = (stores) => {
    if (typeof mapboxgl !== 'object') { return; } // eslint-disable-line no-undef

    const $form = $('.input-wrapper');
    const url = $form.attr('data-store-url');

    markers.forEach((marker) => marker.remove());
    const bbox = new mapboxgl.LngLatBounds(); // eslint-disable-line no-undef

    stores.forEach((store) => {
        const popup = new mapboxgl.Popup().setHTML(''); // eslint-disable-line no-undef
        const element = document.createElement('div');

        element.addEventListener('click', () => {
            const parameters = { pid: store.ID, checkout: true };
            const action = appendToUrl(url, parameters);

            $.ajax({
                url: action,
                type: 'GET',
                dataType: 'json',
                success: (storeData) => {
                    popup.setHTML(storeData.storeTileHtml);
                    popup.addTo(window.mapboxMap);

                    window.mapboxMap.flyTo({
                        center: [store.longitude, store.latitude],
                        speed: 0.3,
                    });

                    $('.js-map-modal-veil').addClass('active');
                    $('.mapboxgl-popup-content').addClass('active');

                    // flyTo has no call back, this works as well:
                    setTimeout(() => {
                        $('body').addClass('no-scroll');
                    }, 1);
                },
            });
        });

        const marker = new mapboxgl.Marker(element) // eslint-disable-line no-undef
            .setLngLat([store.longitude, store.latitude])
            .setPopup(popup)
            .addTo(window.mapboxMap);

        markers.push(marker);
        bbox.extend([store.longitude, store.latitude]);
    });

    window.mapboxMap.fitBounds(bbox, { padding: 50 });
    customPointers();
};

const handleMap = (stores) => {
    const $mapboxWrapper = $('.js-mapbox-map-wrapper');
    const $storesPagination = $('.js-stores-pagination');
    const $toggleMapButton = $('.js-toggle-button-map');
    const isMapActive = $mapboxWrapper.hasClass('mapboxgl-map');
    const isMapView = $toggleMapButton.hasClass('active');
    const hasResults = stores && stores.length > 0;

    if (isMapView && hasResults) {
        $mapboxWrapper.show();
        $storesPagination.hide();

        if (window.mapboxMap) {
            window.mapboxMap.resize();
        }
    } else if (isMapView) {
        $mapboxWrapper.hide();
        $storesPagination.show();
    }

    if (isMapActive && hasResults) {
        showMapboxMarkers(stores);
    }
};

const closeMapModal = () => {
    // injected modal content and close btn
    $(document).on('click', '.mapboxgl-popup-close-button', () => {
        $('.js-map-modal-veil').removeClass('active');
        $('.mapboxgl-popup-content').removeClass('active');
        $('body').removeClass('no-scroll');
    });

    // click the backdrop and close all modals inside the map
    $(document).on('click', '.js-map-modal-veil', () => {
        $('.js-map-modal-veil').removeClass('active');
        $('.mapboxgl-popup-content').removeClass('active');
        $('body').removeClass('no-scroll');
        // if we return from future steps and there is still a modal open
        if ($('.mapboxgl-popup').length > 0) {
            $('.mapboxgl-popup-close-button').trigger('click');
        }
    });
};

/**
 * Handles search stores AJAX response
 * @param {Object} data - Response data
 */
const updateStoresResults = (data) => {
    const $storesPaginationLinkContainer = $('.js-stores-pagination-link-container');
    const $storesPagination = $('.js-stores-pagination');
    const $storesResultMessage = $('.js-stores-result-message');
    const $toggleListButton = $('.js-toggle-button-list');
    const clubfinder = $('input[name=clubfinder]').val();
    const stores = data.mapStores && data.mapStores.clusters ? data.mapStores.clusters : [];
    const storesResultsHtml = data.storesResultsHtml || '';
    const storesResultsMessageHtml = data.storesResultsMessageHtml || '';
    const hasResults = stores.length > 0;
    const showStoresPaginationLink = !data.isComplete && $toggleListButton.hasClass('active');

    handleMap(stores);
    $storesResultMessage.html(storesResultsMessageHtml);
    $storesPagination.html(storesResultsHtml);

    $storesPaginationLinkContainer.attr('data-page-start', data.pageStart);
    $storesPaginationLinkContainer.attr('data-page-size', data.pageSize);
    $storesPaginationLinkContainer.attr('data-page-complete', data.isComplete);

    if (showStoresPaginationLink) {
        $storesPaginationLinkContainer.removeClass('display-none');
    } else {
        $storesPaginationLinkContainer.addClass('display-none');
    }

    if (clubfinder) {
        $(document).trigger('clubFinderResults', [hasResults]);
    }
};

/**
 * Performs search stores AJAX request
 */
const searchStores = () => {
    const $form = $('.input-wrapper');
    const $searchInput = $('input[name=searchterm]');
    const action = $form.attr('action');
    const searchterm = $searchInput.val();
    const filters = getSelectedFilters();
    const searchParams = new URLSearchParams(window.location.search);
    const searchtermParameter = searchParams.get('searchterm');
    const latitude = searchParams.get('latitude');
    const longitude = searchParams.get('longitude');
    const isLocation = searchParams.get('location') === 'true' && searchtermParameter === searchterm;
    const urlParameters = {};

    if (searchterm) {
        urlParameters.searchterm = searchterm;
    }
    if (filters) {
        urlParameters.filters = filters;
    }
    if (latitude) {
        urlParameters.latitude = latitude;
    }
    if (longitude) {
        urlParameters.longitude = longitude;
    }
    if (isLocation) {
        urlParameters.location = isLocation;
    }

    updateUrl(Object.assign({ s: null, sz: null }, urlParameters)); // eslint-disable-line prefer-object-spread

    urlParameters.checkout = true;
    const url = appendToUrl(action, urlParameters);

    $.ajax({
        url,
        type: $form.attr('method'),
        dataType: 'json',
        success: (data) => updateStoresResults(data),
    });
};

/**
 * Initilize browser geolocation prompt on the checkout step 1
 */
const checkoutLocation = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const lat = searchParams.get('latitude');
    const long = searchParams.get('longitude');

    if (lat && long) {
        return;
    }

    /**
     * Handles the success scenario of the geolocation request made on the checkout step 1
     * @param {Object} position - The position object returned by the browser
     */
    const callback = (position) => {
        const $form = $('.input-wrapper');
        const $locationUrl = $('.js-location-address-url');
        const $searchInput = $('input[name=searchterm]');
        const latitude = position.coords.latitude; // eslint-disable-line prefer-destructuring
        const longitude = position.coords.longitude; // eslint-disable-line prefer-destructuring
        const formUrl = $form.attr('data-url');
        const url = `${$locationUrl.val()}?latitude=${latitude}&longitude=${longitude}&checkout=true`;

        $.ajax({
            type: 'GET',
            dataType: 'json',
            url,
            success: (response) => {
                const address = response && response.address;
                const storesObject = response && response.storesObject;

                if (address) {
                    $searchInput.val(address);
                    history.replaceState(null, null, appendToUrl(formUrl, { // eslint-disable-line no-restricted-globals
                        searchterm: address,
                        latitude,
                        longitude,
                        location: true,
                    }));
                }

                if (storesObject) {
                    updateStoresResults(storesObject);
                }
            },
        });
    };

    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(callback);
    }
};

export {
    getSelectedFilters,
    promotionLabelTooltip,
    infoTooltipModal,
    showMapboxMarkers,
    searchStores,
    closeMapModal,
    postalCodeStore,
    checkoutLocation,
};
